// Google Analytics configuration and tracking functions
export const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;

// Initialize Google Analytics
export const initGA = () => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('config', GA_TRACKING_ID, {
            page_title: document.title,
            page_location: window.location.href,
        });
    }
};

// Track page views
export const trackPageView = (url) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('config', GA_TRACKING_ID, {
            page_path: url,
            page_title: document.title,
            page_location: window.location.href,
        });
    }
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', action, {
            event_category: category,
            event_label: label,
            value: value,
        });
    }
};

// Track form submissions
export const trackFormSubmission = (formName) => {
    trackEvent('form_submit', 'engagement', formName);
};

// Track phone calls
export const trackPhoneCall = (phoneNumber) => {
    trackEvent('phone_call', 'engagement', phoneNumber);
};

// Track service inquiries
export const trackServiceInquiry = (serviceName) => {
    trackEvent('service_inquiry', 'engagement', serviceName);
};

// Track button clicks
export const trackButtonClick = (buttonName, location) => {
    trackEvent('button_click', 'engagement', `${buttonName}_${location}`);
};

// Track scroll depth
export const trackScrollDepth = (depth) => {
    trackEvent('scroll_depth', 'engagement', depth);
};

// Track time on page
export const trackTimeOnPage = (timeSpent) => {
    trackEvent('time_on_page', 'engagement', timeSpent);
};
